var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuBox"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.to(item.path, item.id)}}},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }